var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefiniteCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 2.74996H18.2499C18.493 2.74996 18.7262 2.84654 18.8981 3.01844C19.07 3.19035 19.1666 3.42351 19.1666 3.66663V18.3333C19.1666 18.5764 19.07 18.8096 18.8981 18.9815C18.7262 19.1534 18.493 19.25 18.2499 19.25H1.74992C1.5068 19.25 1.27365 19.1534 1.10174 18.9815C0.929829 18.8096 0.833252 18.5764 0.833252 18.3333V3.66663C0.833252 3.42351 0.929829 3.19035 1.10174 3.01844C1.27365 2.84654 1.5068 2.74996 1.74992 2.74996H5.41658V0.916626H7.24992V2.74996H12.7499V0.916626H14.5833V2.74996ZM12.7499 4.58329H7.24992V6.41663H5.41658V4.58329H2.66659V8.24996H17.3333V4.58329H14.5833V6.41663H12.7499V4.58329ZM17.3333 10.0833H2.66659V17.4166H17.3333V10.0833Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefiniteCalendarIcon);
export default __webpack_public_path__ + "static/media/definite-calendar-icon.d13f38fe12c6d5814622e431f92d2d6e.svg";
export { ForwardRef as ReactComponent };